import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SKIP_DELEGATION_CONTEXT } from '../http/skip-delegation-context.token';
import { SKIP_GLOBAL_LOADER } from '../http/skip-global-loader.token';
import { SKIP_SESSION_REFRESH } from '../http/skip-session-refresh.token';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SessionRefreshService {
  private refreshRequest$: Observable<boolean> | null = null;

  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService
  ) {}

  refreshSession(): Observable<boolean> {
    if (this.refreshRequest$) {
      return this.refreshRequest$;
    }

    const base = environment.securityApiUrl || environment.apiUrl.replace(/\/api\/?$/, '');
    const context = new HttpContext()
      .set(SKIP_GLOBAL_LOADER, true)
      .set(SKIP_DELEGATION_CONTEXT, true)
      .set(SKIP_SESSION_REFRESH, true);

    this.refreshRequest$ = this.http.post(`${base}/auth/refresh`, null, {
      withCredentials: true,
      observe: 'response',
      context
    }).pipe(
      map(response => response.status >= 200 && response.status < 300),
      catchError(() => {
        this.auth.clearActiveDelegation();
        this.auth.clearUser();
        return of(false);
      }),
      finalize(() => {
        this.refreshRequest$ = null;
      }),
      shareReplay(1)
    );

    return this.refreshRequest$;
  }
}

